import { sum, multiply, divide, subtract } from "./core.js"

const headerBasic = (data, operation) => {
  const { fieldsToOperate, targetField, basicOp } = operation
  let result = 0

  let runOp

  switch (basicOp) {
    case 'sum':
      runOp = sum
      break;
    case 'multiply':
      runOp = multiply
      break;
    case 'divide':
      runOp = divide
      break;
    case 'subtract':
      runOp = subtract
      break;
    default:
      runOp = sum
      break;
  }

  if (!data) return data

  result = runOp(data, fieldsToOperate)

  // return a new object instead of mutating the input
  return {
    ...data,
    [targetField]: parseFloat(result)
  }
}

export default headerBasic
